var Curriculog = Curriculog || {};


/**
 * A dialog with a promise interface.
 */
Curriculog.PromiseDialog = (function ($, _, Backbone, PromiseDialog) {
    PromiseDialog = Curriculog.Dialog.extend({
        modal: true,
        buttons: {
            'Ok': '_resolve',
            'Cancel': '_reject'
        },

        initialize: function(options) {
            Curriculog.Dialog.prototype.initialize.call(this, options || {});
            this._deferred = $.Deferred();
            this._deferred.promise(this);
        },

        _resolve: _.debounce(function() {
            this._deferred.resolve();
            this.close();
            return this;
        }, 1000, true),

        _reject: _.debounce(function() {
            this._deferred.reject();
            this.close();
            return this;
        }, 1000, true)

    });
    return PromiseDialog;
})($, _, Backbone, Curriculog.PromiseDialog || {});

